import { fetchItem, putItem } from "@/queries/queries-helper";
import ENDPOINTS from "@/services/endpoints";
import DashboardProcessDto from "@/models/interfaces/dtos/dashboard-process-dto";
import StatsProcessDto from "@/models/interfaces/dtos/stats-process-dto";

export type StatsProcessUpdate = Partial<StatsProcessDto> | ((current: StatsProcessDto) => Partial<StatsProcessDto>);
export type CalculationRevisionKey = "revMetresDepuisPDF" | "revMetresDepuisCalcul" | "revCalcul1" | "revCalcul2" | "revCalcul3" | "revSurfaces";

export const updateProjectProcessStatus = async (
    projectId: string,
    update: StatsProcessUpdate,
    isActive: () => boolean = () => true,
) => {
    // Le PUT remplace tout le statut : conserver les valeurs existantes.
    const current = await fetchItem<DashboardProcessDto>(ENDPOINTS.DASHBOARD_PROCESS_STATUS(projectId))
        ?? await fetchItem<StatsProcessDto>(ENDPOINTS.DASHBOARD_INITIAL_PROCESS_STATUS(projectId));
    if (!isActive()) return;
    if (!current) throw new Error("Impossible d'initialiser le statut du projet.");

    const stats: StatsProcessDto = {
        revision: current.revision,
        is2D: current.is2D,
        is3D: current.is3D,
        revMetresDepuisPDF: current.revMetresDepuisPDF,
        revMetresDepuisCalcul: current.revMetresDepuisCalcul,
        revPreparationCoques: current.revPreparationCoques,
        revDestinationsCoques: current.revDestinationsCoques,
        revSurfaces: current.revSurfaces,
        revMetresCarbone: current.revMetresCarbone,
        revMetresQuantitatifGOE: current.revMetresQuantitatifGOE,
        revQuantitatifLotMex: current.revQuantitatifLotMex,
        revQuantitatifLotMenuiseries: current.revQuantitatifLotMenuiseries,
        revAmenagementsAppartements: current.revAmenagementsAppartements,
        revSurfacesPrecisesSOE: current.revSurfacesPrecisesSOE,
        revCalcul1: current.revCalcul1,
        revCalcul2: current.revCalcul2,
        revCalcul3: current.revCalcul3,
    };
    await putItem(ENDPOINTS.DASHBOARD_UPDATE_PROCESS_STATUS(projectId), {
        ...stats,
        ...(typeof update === "function" ? update(stats) : update),
    });
};

export const markProjectCalculationDone = (projectId: string, key: CalculationRevisionKey, isActive: () => boolean) =>
    updateProjectProcessStatus(projectId, current => {
        if (!current.revision) throw new Error("La révision du projet est introuvable.");
        return { [key]: current.revision };
    }, isActive);
